import { apiClient } from './apiClient';
import { Supplier, CreateSupplierRequest, UpdateSupplierRequest } from '../types';

class SupplierService {
  async getSuppliers(params?: {
    search?: string;
    status?: 'all' | 'active' | 'inactive';
    supplier_type?: string;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
    per_page?: number;
  }): Promise<Supplier[]> {
    const response = await apiClient.get<Supplier[]>('/suppliers', { params });
    return response;
  }

  async getSupplier(id: number): Promise<Supplier> {
    const response = await apiClient.get<Supplier>(`/suppliers/${id}`);
    return response;
  }

  async createSupplier(data: CreateSupplierRequest): Promise<Supplier> {
    const response = await apiClient.post<{ supplier: Supplier }>('/suppliers', data);
    return response.supplier;
  }

  async updateSupplier(id: number, data: UpdateSupplierRequest): Promise<Supplier> {
    const response = await apiClient.put<{ supplier: Supplier }>(`/suppliers/${id}`, data);
    return response.supplier;
  }

  async deleteSupplier(id: number): Promise<void> {
    await apiClient.delete(`/suppliers/${id}`);
  }

  async bulkDeleteSuppliers(ids: number[]): Promise<void> {
    await apiClient.post('/suppliers/bulk-delete', { ids });
  }

  async getSupplierStatistics(): Promise<{
    total_suppliers: number;
    active_suppliers: number;
    inactive_suppliers: number;
    total_products: number;
  }> {
    const response = await apiClient.get('/suppliers/statistics');
    return response as any;
  }
}

export const supplierService = new SupplierService();
